function addInitialCapital(data, report) {
    const values = data.map((tuple) => tuple.equity);
    values.unshift(Number(report.initial_capital));
    const labels = data.map((tuple) => tuple.date);
    labels.unshift('Início');
    return { values, labels };
}
function generateData(data, initialCapital) {
    return data
        .split(',')
        .reduce((accumulator, date, index, array) => {
        if ((index + 1) % 3 === 0 && index > 0) {
            accumulator.push({
                date: array[index - 2],
                isWorkday: array[index - 1] === '1',
                equity: Number(initialCapital) * Number.parseFloat(array[index])
            });
        }
        return accumulator;
    }, [])
        .filter((tuple, index) => tuple.isWorkday && index !== 0);
}
export const generateChartData = (data, report) => {
    if (!data)
        return { labels: [], values: [] };
    return addInitialCapital(generateData(data, report.initial_capital), report);
};
//# sourceMappingURL=robotChart.js.map